import React from 'react';
import PropTypes from 'prop-types';
import { ScorersWrapper, Scorers, Scorer, GoalType, PlayerName } from './styles';

const MatchRowScorers = ({
  scorers, color, size, weight, marginLeft, font, align,
}) => (
  <ScorersWrapper>
    <Scorers
      marginLeft={marginLeft}
      color={color}
      size={size}
      weight={weight}
      align={align}
    >
      {scorers && scorers.map((scorer, index) => (
        <Scorer
          key={index}
          font={font}
          align={align}
        >
          <PlayerName>
            {scorer.getIn(['goalPlayer', 'formatName'])}
          </PlayerName>
          {scorer.get('goalType') && (scorer.get('goalType') === 'Penalty') &&
            <GoalType font={font}>(rig.)</GoalType>
          }
          {scorer.get('goalType') && (scorer.get('goalType') === 'Own') &&
            <GoalType font={font}>(AG)</GoalType>
          }
          {scorer.get('goalAbsoluteTime') ? `${scorer.get('goalAbsoluteTime')}'` : ''}
        </Scorer>
      ))}
    </Scorers>
  </ScorersWrapper>
);

MatchRowScorers.propTypes = {
  scorers: PropTypes.any,
  color: PropTypes.string,
  size: PropTypes.number,
  weight: PropTypes.string,
  marginLeft: PropTypes.number,
  font: PropTypes.string,
  align: PropTypes.string,
};

export default MatchRowScorers;



// WEBPACK FOOTER //
// ./src/components/shared/MatchRowScorers/index.js